import { useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';

/**
 * @param {{ clientId: string | number, readOnly?: boolean }} props
 */
export function ClientDocumentsSection({ clientId, readOnly = false }) {
  const [documents, setDocuments] = useState([]);
  const [label, setLabel] = useState('');
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = () =>
    apiJson(`/api/admin/clients/${clientId}/documents`)
      .then(setDocuments)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));

  useEffect(() => {
    setLoading(true);
    void load();
  }, [clientId]);

  const add = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await apiJson(`/api/admin/clients/${clientId}/documents`, {
        method: 'POST',
        body: { label: label.trim(), url: url.trim() },
      });
      setLabel('');
      setUrl('');
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const remove = async (docId) => {
    setError('');
    try {
      await apiJson(`/api/admin/clients/${clientId}/documents/${docId}`, { method: 'DELETE' });
      await load();
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) {
    return <p className="muted">Loading documents…</p>;
  }

  return (
    <div>
      {error ? <p className="err">{error}</p> : null}
      {documents.length ? (
        <ul className="list-plain">
          {documents.map((doc) => (
            <li key={doc.id} className="row-actions" style={{ justifyContent: 'space-between', marginBottom: '0.35rem' }}>
              <a href={doc.url} target="_blank" rel="noreferrer">
                {doc.label}
              </a>
              {!readOnly ? (
                <button type="button" className="btn-link" onClick={() => void remove(doc.id)}>
                  Remove
                </button>
              ) : null}
            </li>
          ))}
        </ul>
      ) : (
        <p className="muted">No documents yet.</p>
      )}
      {!readOnly ? (
        <form onSubmit={add} className="stack" style={{ marginTop: '1rem' }}>
          <div className="inline-two">
            <input placeholder="Label" value={label} onChange={(e) => setLabel(e.target.value)} required />
            <input placeholder="https://…" value={url} onChange={(e) => setUrl(e.target.value)} required />
          </div>
          <button type="submit" className="btn-secondary" disabled={saving}>
            {saving ? 'Adding…' : 'Add document link'}
          </button>
        </form>
      ) : null}
    </div>
  );
}
